import "./index.css";
import SvgComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";

/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @param {Object} props
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {boolean} props.state - is this switch enabled or not
 * @returns {JSX.Element}
 */
const CommonSplitView = ({ state, isDisabled, handleClick }) => {
  return (
    <div
      onClick={(e) => {
        if (!isDisabled) handleClick(e);
      }}
      className={`relative flex items-center py-padding-button-m bg-primary-bg w-splitview-btn-width ${isDisabled ? "cursor-not-allowed opacity-light-opacity" : "cursor-pointer global-hover-white"}  z-z-index-base rounded-border-radius-md`}
    >
      <div className="flex gap-x-gap-button-s relative  h-icon-sm w-splitview-btn-width max-w-splitview-btn-width">
        <p
          className={`${state ? "splitviewanimatetext-left ml-margin-button-l " : "splitviewanimatetext-right mr-margin-button-l"} text-text-primary text-font-xxs w-max absolute`}
        >
          Split view
        </p>

        <div
          className={`${state ? "splitviewanimate-right mr-margin-sm ml-margin-button-l" : "splitviewanimate-left mr-margin-button-l ml-margin-sm"} z-z-index-content absolute`}
        >
          <SvgComponent
            height="var(--icon-sm)"
            width="var(--icon-sm)"
            url={state ? ICONS?.SPLIT_VIEW_COLOR : ICONS?.SPLIT_VIEW}
            alt="List"
          />
        </div>
      </div>
    </div>
  );
};

export default CommonSplitView;
